import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Card } from 'react-bootstrap';

export type SelectableDefaultBankCardProps = {
  title?: string;
  subtitle?: string;
  onClick?: React.MouseEventHandler;
};

const SelectableDefaultBankCard = ({
  title = 'Add new',
  subtitle,
  onClick,
}: SelectableDefaultBankCardProps) => {
  return (
    <Card
      bsPrefix={'cnd-bank-card'}
      onClick={onClick}
      className={'default d-flex flex-column align-items-center'}
    >
      <div
        className={
          'cnd-bank-card--image-wrapper d-flex justify-content-center align-items-center'
        }
      >
        <FontAwesomeIcon icon={light('plus')} />
      </div>
      <Card.Body
        className={
          'd-flex flex-column justify-content-start align-items-center'
        }
      >
        <Card.Title>{title}</Card.Title>
        <Card.Subtitle>{subtitle}</Card.Subtitle>
      </Card.Body>
    </Card>
  );
};

export default SelectableDefaultBankCard;
